<template>
  <v-row no-gutters justify="center" align-content="center" style="height: 25vh; min-height: 300px">
    <div v-if="useIcon" style="width: 100%">
      <v-icon :size="iconSize" color="#3254B9">{{ icon }}</v-icon>
    </div>
    <span class="text_no_data" v-html="text"/>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: "NoData",
  props: {
    text: {
      default: 'Здесь пусто...',
      type: String,
    },
    useIcon: {
      default: true,
      type: Boolean,
    },
    icon: {
      default: 'inbox',
      type: String,
    },
    iconSize: {
      default: 100,
      type: Number,
    },
  }
})
</script>

<style scoped lang="scss">
.text_no_data {
  padding: 0 40px;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 51px;
  text-align: center;
  color: #34347C;
}

@media screen and (max-width: 768px) {
  .text_no_data {
    padding: 0 20px;
    font-size: 24px;
    line-height: 37px;
  }
}
</style>
